import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import { FloatingInputComponent } from '../../../../../framework/inputs/floating-input/floating-input.component';
import {
  IBudgetTemplate,
  IBudgetTemplateItem,
} from '../../../../../store/templates/templates.types';
import { templatesActions } from '../../../../../store/templates/templates.actions';
import { CurrentUserService } from '../../../../../services/current-user.service';
import {
  isGCTemplateItem,
  isManagerTemplateItem,
} from '../../../../../store/templates/templates.constants';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-template-item-project-budget',
  imports: [FloatingInputComponent, CdkDragHandle, NgClass, FormsModule],
  templateUrl: './template-item-project-budget.component.html',
  styleUrl: './template-item-project-budget.component.scss',
})
export class TemplateItemProjectBudgetComponent {
  @Input({ required: true }) template: IBudgetTemplate;
  @Input({ required: true }) templateItem: IBudgetTemplateItem;

  readonly isManagerTemplate = isManagerTemplateItem;
  protected readonly isGCTemplateItem = isGCTemplateItem;

  store = inject(Store);
  userService = inject(CurrentUserService);

  minusClicked() {
    this.store.dispatch(
      templatesActions.removeBudgetTemplateItem({ itemId: this.templateItem.id }),
    );
  }

  plusClicked() {
    if (this.userService.isManager) {
      this.onAddItem();
      return;
    }

    this.onAddSubitem();
  }

  fieldChanged(field: 'account_code' | 'division' | 'cost_type' | 'description', value: string) {
    this.store.dispatch(
      templatesActions.updateBudgetTemplateItem({
        templateItemId: this.templateItem.id,
        templateItem: { [field]: value },
      }),
    );
  }

  onAddItem() {
    this.store.dispatch(
      templatesActions.addEmptyBudgetTemplateItem({ isManager: this.userService.isManager }),
    );
  }

  onAddSubitem() {
    this.store.dispatch(
      templatesActions.addEmptySubitemToBudgetTemplateItem({ itemId: this.templateItem.id }),
    );
  }
}
